<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/infos" name="參觀資訊" icon="ti-panel"/>
        <sidebar-link to="/horoscope" name="卡牌列表" icon="ti-panel"/>
        <sidebar-link to="/exhibitions" name="展覽列表" icon="ti-panel"/>
        <sidebar-link to="/artists" name="藝術家" icon="ti-panel"/>
        <div class="side-separator"></div>
        <sidebar-link to="/staffs" name="館方人員" icon="ti-panel"/>
        <sidebar-link to="/permission" name="權限管理" icon="ti-panel"/>
        <sidebar-link to="/account" name="帳號管理" icon="ti-panel"/>
        <div class="side-separator"></div>
        <sidebar-link to="/beacons" name="裝置總覽" icon="ti-panel"/>
        <sidebar-link to="/notification/beacon" name="裝置推播管理" icon="ti-panel"/>
        <div class="side-separator"></div>
        <sidebar-link to="/notification/firebase" name="Firebase-推播管理" icon="ti-panel"/>
        <sidebar-link to="/notification/gps" name="GPS-推播管理" icon="ti-panel"/>
        <sidebar-link to="/levels" name="關卡列表" icon="ti-panel"/>
        <!--
        <sidebar-link to="/transfer" name="轉換資料" icon="ti-panel"/>
        -->
      </template>
      <slot>
      </slot>
      <mobile-menu>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down class="nav-item"
                   title="5 Notifications"
                   title-classes="nav-link"
                   icon="ti-bell">
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-settings"></i>
            <p>Settings</p>
          </a>
        </li>
        <li class="divider"></li>
      </mobile-menu>
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>
      <dashboard-content @click.native="toggleSidebar">

      </dashboard-content>
      <!--
      <content-footer></content-footer>
      -->
    </div>
  </div>
</template>
<style lang="scss">
</style>
<script>
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu
  },
  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    }
  }
};
</script>

<style lang="scss">
  .side-separator {
    width: 90%;
    height: 1px;
    background: rgba(255, 255, 255, 0.2);
    margin: auto;
  }
</style>
